<template>
  <AdminDevicesPage />
</template>

<script setup lang="ts">
import { useSeoMeta } from "@unhead/vue";
import AdminDevicesPage from "shared-ui/pages/AdminDevicesPage.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("device_inventory.title"),
});

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
